<template>
  <div class="card-body maxheight">
    <div class="row">
    <div class="col">
      <div class="row justify-content-center">
        <div class="col-8 text-center">
        <h3> MSD Pledge Onboarding Questionnaire</h3>
        
        <p class="small"> Please ensure you have signed the pledge<br>before completing this questionnaire</p>
        </div>
      </div>
      <hr>
      <div class="row mx-auto justify-content-center">
        <div class="col-8">
        <p v-for="(item,index) in data.title" :key="index">{{ item }}</p>
      <div class="row mt-2 mr-auto ml-2">
        <ul>
            <li v-for="(item,index) in data.responses" :key="index">&#9679; {{item}}</li>
        </ul>
      </div>
      </div>
      </div>
    </div>
    
  </div>
  </div>
  <div class="card-footer border border-rounded">
    <div class="row justify-content-center">
      <div
      @click="$emit('nextQuestion', 2, true)"
      class="btn btn-small nsc-cta blue mx-2 my-2"
    >
      Let's go!
    </div>
    </div>
  </div>
</template>
<script>
export default {
    name:"Introduction",
    props: ["data"],
    emits: ["nextQuestion"],
}
</script>